import React, {useEffect, useState} from "react";
import {Helmet} from "react-helmet";

import Popup from '../popup/popup'
import Backdrop from '../backdrop/backdrop'

import pageStyles from './page.module.scss'
import popupStyles from '../popup/popup.module.scss'


const Page = ({markdownRemark}) => {

    useEffect(() => {
        let pageImages = document.querySelectorAll('#page img');
        for (let img of pageImages) {
            img.addEventListener('click', onImgClick)
        }
        return () => {
            for (let img of pageImages) {
                img.removeEventListener('click', onImgClick);
            }
        };
    }, []);

    const [isImgZoomed, setImgZoomed] = useState(false);
    const [zoomedImg, setZoomedImg] = useState(null);


    let popupCloseHandler = () => {
        setImgZoomed(false);
        setZoomedImg(null)
    };

    let onImgClick = (e) => {
        setImgZoomed(true);
        setZoomedImg(e.target.src)
    };


    return (
        <div id="page" className={pageStyles.page}>
            <Helmet>
                <title>{`Semograph - ${markdownRemark.frontmatter.title}`}</title>
            </Helmet>
            <Backdrop show={isImgZoomed}/>
            <Popup show={isImgZoomed} onClosePopup={popupCloseHandler}>
                <img className={popupStyles.popupImg} id="popup-img" alt="popup-img" src={zoomedImg}/>
            </Popup>
            <h1>{markdownRemark.frontmatter.title}</h1>
            <div dangerouslySetInnerHTML={{__html: markdownRemark.html}}></div>
        </div>
    )
};

export default Page;
